import simplifies from "../../../assets/salusion-simplifies.svg"

import SalusionAccordion from "./SalusionAccordion"

export default function SalusionSimplifies() {
	return (
		<section id="salusion_simplifies">
			<div className="row align-items-center">
				<div className="col-12 col-lg-8 col-md-6">
					<div className="simplifies-img">
						<img
							src={simplifies}
							alt="Administer QSEHRAs and ICHRAs in minutes — compliant, automated, and affordable"
						/>
					</div>
				</div>
				<div className="col-12 col-lg-4 col-md-6">
					<div className="simplifies-accordion">
						<h2 className="section-heading">
							Salusion Simplifies <br /> HRA Benefits Administration
						</h2>
						<SalusionAccordion />
					</div>
				</div>
			</div>
		</section>
	)
}
